import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { LoaderComponent } from './loader/loader.component';
import { HttploadingSpinnerComponent } from './httploading-spinner/httploading-spinner.component';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { FreeTrailComponent } from './free-trail/free-trail.component';
import { ToggleButtonComponent } from './toggle-button/toggle-button.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { IframePollingComponent } from './iframe-polling/iframe-polling.component';
import { FormsModule } from '@angular/forms';
 import { PaymentSourceComponent } from './payment-source/payment-source.component';
// import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [TranslateModule, CommonModule, NgbProgressbarModule, NgxMaskDirective, NgxMaskPipe, FormsModule, FormsModule],
  declarations: [
    LoaderComponent,
    HttploadingSpinnerComponent,
    FreeTrailComponent,
    ToggleButtonComponent,
    EmptyStateComponent,
    IframePollingComponent,
    // PaymentSourceComponent
  ],
  exports: [
    LoaderComponent,
    HttploadingSpinnerComponent,
    FreeTrailComponent,
    ToggleButtonComponent,
    EmptyStateComponent,
    IframePollingComponent,
    // PaymentSourceComponent
  ],
  providers: [provideNgxMask()],
})
export class SharedModule {}
